import { Button } from "@/components/ui/button";

export function CTASection() {
  return (
    <section className="py-32 relative overflow-hidden border-t border-border/40">
      <div className="absolute inset-0 bg-primary/5" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/20 blur-[100px] pointer-events-none" />
      
      <div className="container mx-auto px-6 relative z-10 text-center max-w-3xl">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8">
          Detect unlawful communication in real time and at scale.
        </h2>
        <p className="text-lg text-muted-foreground mb-10">
          Join the enterprises using HarmCheck to secure their communications.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button size="lg" className="h-14 px-10 text-base rounded-none bg-primary hover:bg-primary/90 text-primary-foreground" asChild>
            <a href="/book-a-demo">Request a Demo</a>
          </Button>
        </div>
      </div>
    </section>
  );
}
